import React, { useState } from 'react';

const SocialMediaSection = ({ socialMediaData }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!socialMediaData || !socialMediaData.value) {
        return null;
    }

    const platforms = socialMediaData.platforms || [];
    
    if (platforms.length === 0) {
        return null;
    }

    const visiblePlatforms = isExpanded ? platforms : platforms.slice(0, 3);
    const hasMore = platforms.length > 3;

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Social Media</h4>
            <div style={{
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '6px',
                padding: '20px'
            }}>
                <div style={{
                    fontSize: '12px',
                    color: '#a0a0a0',
                    textTransform: 'uppercase',
                    marginBottom: '12px',
                    fontWeight: '600',
                    letterSpacing: '0.5px'
                }}>
                    Platforms ({platforms.length} {platforms.length === 1 ? 'platform' : 'platforms'})
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {visiblePlatforms.map((platform, index) => {
                        const urls = platform.urls || [];
                        const foundOn = platform.found_on || [];
                        const platformName = platform.platform || `Platform ${index + 1}`;

                        return (
                            <div key={index} style={{
                                backgroundColor: '#262626',
                                border: '1px solid #373737',
                                borderRadius: '4px',
                                padding: '16px'
                            }}>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#e0e0e0',
                                    marginBottom: '12px',
                                    textTransform: 'capitalize'
                                }}>
                                    {platformName}
                                </div>

                                {urls.length > 0 && (
                                    <div style={{ marginBottom: '12px' }}>
                                        <div style={{
                                            fontSize: '11px',
                                            color: '#909090',
                                            textTransform: 'uppercase',
                                            marginBottom: '8px',
                                            fontWeight: '600',
                                            letterSpacing: '0.5px'
                                        }}>
                                            URLs ({urls.length})
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                            {urls.map((url, urlIndex) => (
                                                <a
                                                    key={urlIndex}
                                                    href={url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        color: '#60a5fa',
                                                        textDecoration: 'none',
                                                        fontSize: '13px',
                                                        padding: '6px 10px',
                                                        backgroundColor: '#1f1f1f',
                                                        borderRadius: '3px',
                                                        border: '1px solid #2d2d2d',
                                                        transition: 'all 0.2s ease',
                                                        wordBreak: 'break-all'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor = '#262626';
                                                        e.target.style.textDecoration = 'underline';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor = '#1f1f1f';
                                                        e.target.style.textDecoration = 'none';
                                                    }}
                                                >
                                                    {url}
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {foundOn.length > 0 && (
                                    <div>
                                        <div style={{
                                            fontSize: '11px',
                                            color: '#909090',
                                            textTransform: 'uppercase',
                                            marginBottom: '8px',
                                            fontWeight: '600',
                                            letterSpacing: '0.5px'
                                        }}>
                                            Found On ({foundOn.length} {foundOn.length === 1 ? 'page' : 'pages'})
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                            {foundOn.map((pageUrl, pageIndex) => (
                                                <a
                                                    key={pageIndex}
                                                    href={pageUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        color: '#a78bfa',
                                                        textDecoration: 'none',
                                                        fontSize: '13px',
                                                        padding: '6px 10px',
                                                        backgroundColor: '#1f1f1f',
                                                        borderRadius: '3px',
                                                        border: '1px solid #2d2d2d',
                                                        transition: 'all 0.2s ease',
                                                        wordBreak: 'break-all'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor = '#262626';
                                                        e.target.style.textDecoration = 'underline';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor = '#1f1f1f';
                                                        e.target.style.textDecoration = 'none';
                                                    }}
                                                >
                                                    {pageUrl}
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
                {hasMore && (
                    <button
                        onClick={() => setIsExpanded(!isExpanded)}
                        style={{
                            marginTop: '16px',
                            padding: '8px 16px',
                            backgroundColor: '#3d3d3d',
                            border: '1px solid #505050',
                            borderRadius: '4px',
                            color: '#e0e0e0',
                            fontSize: '13px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            alignSelf: 'flex-start'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#4d4d4d';
                            e.target.style.borderColor = '#606060';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#3d3d3d';
                            e.target.style.borderColor = '#505050';
                        }}
                    >
                        {isExpanded ? `Show Less` : `Show More (${platforms.length - 3} more)`}
                    </button>
                )}
            </div>
        </div>
    );
};

export default SocialMediaSection;





